import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/pages/IndexPage.vue"),
  },
  {
    path: "/project",
    name: "project",
    component: () => import("@/pages/OurProjectPage.vue"),
  },
  {
    path: "/project/:id",
    name: "projectDetails",
    component: () => import("@/pages/ProjectDetailsPage.vue"),
    props: true,
  },
  {
    path: "/blog/:pageNumber?",
    name: "blog",
    component: () => import("@/pages/BlogPage.vue"),
  },
  {
    path: "/style/:id",
    name: "blogDetails",
    component: () => import("@/pages/BlogDetailsPage.vue"),
    props: true,
  },
  {
    path: "/:CatchAll(.*)",
    name: "404",
    component: () => import("@/pages/NotFound.vue"),
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, form, savePosition) {
    if (to.name == "blogDetails" || to.name == "blog") return;

    return { top: 0 };
  },
});
export default router;
